import { mergeMapByKey } from '@lib/utils'

import { ChatState, UnknownThreadEventCapturedPayload } from '../types'

export const onUnknownThreadEventCaptured = (
  state: ChatState,
  { conversation, ...payload }: UnknownThreadEventCapturedPayload
): ChatState => {
  const conversations: ChatState['conversations'] = {
    ...state.conversations,
    [conversation.id]: conversation,
  }

  const listings = mergeMapByKey(payload.listings, state.listings, 'id')
  const accounts = mergeMapByKey(payload.accounts, state.accounts, 'id')

  return {
    ...state,
    conversations,
    accounts,
    listings,
  }
}
